import { FC, ReactElement } from 'react';
import cn from 'classnames';

interface Props {
  children: ReactElement | ReactElement[];
  className?: string;
}

// Unified compendium-constraints for the content
const Constraints: FC<Props> = ({ children, className }) => {
  const mergedClassName = cn(className, 'compendium-constraints w-full');

  return <div className={mergedClassName}>{children}</div>;
};

export default Constraints;
